import type { ReactNode } from 'react';

export const symbol_history_edu: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M321-160q-24 0-42-18t-18-42v-70q0-13 8.5-21.5T291-320h94v-127q-36 3-70.5-9T252-491q-5-5-8-10.5t-3-12.5v-44h-38q-6 0-11-2t-10-7l-98-98q-10-10-9.5-23.5T86-710q32-26 76.5-41t85.5-15q30 0 68.5 9.5T385-726v-14q0-25 17.5-42.5T445-800h335q25 0 42.5 17.5T840-740v475q0 44-30.5 74.5T735-160H321Zm124-160h215q13 0 21.5 8.5T690-290v25q0 20 12.5 32.5T735-220q20 0 32.5-12.5T780-265v-475H445v57l232 232q8 8 9 16.5t-2 16.5q-3 8-10 13.5t-18 5.5q-6 0-11.5-2t-10.5-7L517-525l-17 20q-13 15-26 23t-29 15v147ZM218-618h53q13 0 21.5 8.5T301-588v59q17 11 33.5 16.5T368-507q25 0 51-13.5t38-27.5l17-20-69-69q-32-32-72-50.5T248-706q-27 0-49 6.5T154-682l64 64Zm412 358H321v40h323q-6-6-10-16.5t-4-23.5Zm-309 40v-40 40Z"
		/>
	</svg>
);
